import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import {
  notificationWidgetsLayoutAtom,
  notificationTxsWidgetAtom,
} from '../atoms'

import { NotificationWidgetTx } from './notification-widget-tx'
import { NotificationWidgetProfile } from './notification-widgets-profile'
import { NotificationWidgetWallets } from './notification-widgets-wallets'

import type { NotificationWidget, NotificationWidgetVariant } from '../model'

export const NotificationWidgets: React.FC = () => {
  const [txs] = useAtom(notificationTxsWidgetAtom)
  const [layout] = useAtom(notificationWidgetsLayoutAtom)

  const widgets: Record<
    NotificationWidget,
    (variant: NotificationWidgetVariant) => React.ReactNode
  > = {
    profile: (variant) => <NotificationWidgetProfile variant={variant} />,
    wallets: (variant) => <NotificationWidgetWallets variant={variant} />,
    txs: (variant) => <NotificationWidgetTx txs={txs} variant={variant} />,
  }

  return (
    <Root>
      {[...layout]
        .sort((left, right) => left.order - right.order)
        .map(({ widget, variant }) => (
          <WidgetSlot key={widget} data-variant={variant}>
            {widgets[widget](variant)}
          </WidgetSlot>
        ))}
    </Root>
  )
}

const Root = styled.div`
  background: var(--backgroundA-2);

  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5px;

  border-radius: 10px;
  padding: 6px;
`

const WidgetSlot = styled.div`
  display: grid;

  &[data-variant='row'] {
    grid-column: 1 / -1;
  }
`
